import React from "react";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import AmoModal from "components/AmoModal";

/**
 * @param {object} props - object containing props for this component
 * @param {boolean} props.showModal - controls visibility of the modal
 * @param {Function} props.closeModal - function triggered when closing the modal
 * @returns - the Help Reconciliation modal, styled for the AMO project
 */
const ReconciliationChangeEditHelpModal = (props) => {
  const { showModal, closeModal } = props;

  return (
    <AmoModal
      data-testid="reconciliationChangeEditHelpModal"
      open={showModal}
      variant="default"
      title="The Reconciliation Page"
      width="50rem"
      showButton
      closePopover={() => closeModal()}
      buttonsLeftSpacer={5}
      buttons={[
        {
          key: "close",
          label: "Close",
          color: "primary",
          variant: "outlined",
          width: "9rem",
          onClick: () => {
            closeModal();
          },
        },
      ]}
    >
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        This page allows you to edit details describing a change logged in the
        database.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        Changes are logged as they are made. Revisions should be rare; this
        function is provided to facilitate corrections. Only the reason for the
        change, authority for the change, and backup (i.e., email or document
        authorizing the change) can be edited.
      </Typography>
      <Grid item>&nbsp;</Grid>
      <Typography variant="body1">
        Click “Save” to save your changes when you are done. Click “Cancel”
        otherwise.
      </Typography>
      <Grid item>&nbsp;</Grid>
    </AmoModal>
  );
};

ReconciliationChangeEditHelpModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ReconciliationChangeEditHelpModal;
